import React from "react";

import parse from "html-react-parser";

class Whoweare extends React.Component {
  render() {
    const content = this.props.content || {};
    const description = content.summary || content.content1 || "";

    return (
      <>
        <main id="whoweare">
          <section className="who-we-are-section">
            <div className="who-we-are-panel-dad">
              <div className="who-we-are-panel">
                <h2 className="who-we-are-title">WHO WE ARE</h2>
                <p className="who-we-are-description">{parse(description)}</p>
              </div>
            </div>
          </section>
        </main>
      </>
    );
  }
}
export default Whoweare;

